import React, { ReactNode } from 'react';
import { AuthProvider } from '../contexts/AuthContext';

interface FirebaseProviderProps {
  children: ReactNode;
}

/**
 * Firebase Provider component that wraps all Firebase-related providers
 * Currently includes:
 * - AuthProvider: For authentication state
 * 
 * In the future, you can add more Firebase-related providers here:
 * - FirestoreProvider: For real-time Firestore data
 * - StorageProvider: For Firebase Storage
 * - etc.
 */
export const FirebaseProvider: React.FC<FirebaseProviderProps> = ({ children }) => {
  return (
    <AuthProvider>
      {children}
    </AuthProvider>
  );
};

export default FirebaseProvider; 